import { makeSelectors } from '@utils/css';

const modifiers = makeSelectors({
  disabled: "dibde5tcw2",
  listboxOpen: "dibl1jp9plu"
});
const wrapper = "dibw2wt3qa";
const button = "dibbh8okw1";
const chevronWrapper = "dibc1m7jp2l";
const listboxWrapper = "dibl8mtm1n";
const listbox = "diblb3o53m";
const headingWrapper = "dibhesfe41";
const headingSeparator = "dibhmp2lzr";
const selectSelectors = makeSelectors({
  wrapper,
  button,
  listboxWrapper
});

export { button, chevronWrapper, headingSeparator, headingWrapper, listbox, listboxWrapper, modifiers, selectSelectors, wrapper };
import "./select.style.linaria.module.css";
//# sourceMappingURL=select.style.js.map
